/** requête calcul d'itinéraire */
export const journeysRequest = `{
  journeys(
    from: $from
    to: $to
    datetime: $date
    modes: $modes
    allowBss: $allowBss
    datetimeRepresents: $datetimeRepresents,
    algorithmType: $algorithmType
  ) 
  {
    carbonFootprintByCar
    journeys {
        departureDateTime
        requestedDateTime
        carbonFootprint
        arrivalDateTime
        sections {
          id
          duration
          geojson
          transferType
          departureDateTime
          arrivalDateTime
          ... on PublicTransportSection {
            code
            color
            textColor
            commercialMode
            direction
            label
            stopDateTimes {stopPoint {name}}
          }
          from {
            id
            name
            ...on StopPoint {
              administrativeRegions {
                name
              }
            }
          }
          to {
            id
            name
            ...on StopPoint {
              administrativeRegions {
                name
              }
            }
          }
        }
        from {
          id
          name
          coord
          label
          ... on StopArea {
            stopPoints {id}
            departures{route{id}}
          }
          ... on Address {
            houseNumber
          }
          ... on StopPoint {
            equipments,
            stopArea {id}
          }
          ... on AdministrativeRegion {
            level,
            zipCode
          }
          ... on PoiPlace {
            id
            name
          }
        }
      to {
        id
        name
        coord
        label
        ... on StopArea {
          stopPoints {id}
          departures{route{id}}
        }
        ... on Address {
          houseNumber
        }
        ... on StopPoint {
          equipments,
          stopArea {id}
        }
        ... on AdministrativeRegion {
          level,
          zipCode
        }
        ... on PoiPlace {
          id
          name
        }
      }
    }
  }
}`;


/** requête réseaux triés par distance */
export const networksByDistance = `{
  networks(
    sort: DISTANCE_ASC
    coord: $coord
    osmLevel: $osmLevel
    distance: 10
    limit: $limit
    offset: $offset
    search: $search
  ) {
    networks {
      id
      name
      distance
    }
    pagination {
     limit
     offset
     totalCount
     hasNextPage
   }
  }
}
`;

/** requête réseaux triés par nom */
export const networksByName = `{
  networks(
    sort: ALPHA_ASC
    osmLevel: $osmLevel
    limit: $limit
    search: $search
    offset: $offset
  ) {
    networks {
      id
      name
    }
    pagination {
      limit
      offset
      totalCount
      hasNextPage
    }
  }
}
`;

/** requête réseaux triés par nom */
export const networksCoordinates = `{
  networks(
    sort: ALPHA_ASC
    osmLevel: $osmLevel
    limit: $limit
    search: $search
    offset: $offset
  ) {
    networks {
      id
      name
      region {
        center
      }
    }
    pagination {
      limit
      offset
      totalCount
      hasNextPage
    }
  }
}
`;